import api from '@/store/api';

/**
 * Retrieves the list of orders.
 * @returns {Promise<Array>} A promise that resolves to an array of order data.
 */
const getOrderList = ({ commit }) => {
  const url = '/Order/List';
  return api.get(url).then((response) => {
    commit('setOrderList', response.data);
    return response.data;
  });
};

/**
 * Retrieves an order by its ID.
 *
 * @param {any} _ - The placeholder parameter.
 * @param {string} id - The ID of the order to retrieve.
 * @returns {Promise<any>} A promise that resolves to the order data.
 */
const getOrder = ({ commit }, id) => {
  commit('setCurrentOrder', null);
  const url = `/Order/Details/${id}`;
  return api.get(url).then((response) => {
    commit('setCurrentOrder', response.data);
    return response.data;
  });
};

export default {
  getOrderList,
  getOrder
};
